import React from 'react';
import FunnelFooterV2 from '../../../Footer/FunnelFooterV2';

const Footer: React.FC = () => {
  return <FunnelFooterV2 />;
};

export default Footer;
